import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { teamsIconClassNames } from './components/Icon/svg';

var getIconFillOrOutlineStyles = function getIconFillOrOutlineStyles(_ref) {
  var _ref2;

  var outline = _ref.outline;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(teamsIconClassNames.filled), {
    display: outline ? 'none' : 'block'
  }), _defineProperty(_ref2, "& .".concat(teamsIconClassNames.outline), {
    display: outline ? 'block' : 'none'
  }), _ref2;
};

export default getIconFillOrOutlineStyles;